// extracted by mini-css-extract-plugin
export var animationContainer = "_mn-0";
export var footer = "_mn-1";
export var gray = "_mn-2";
export var lineItem = "_mn-3";
export var lineItemImage = "_mn-4";
export var lineItemInfo = "_mn-5";
export var lineItemText = "_mn-6";
export var lineItems = "_mn-7";
export var modalContent = "_mn-8";
export var options = "_mn-9";
export var orderName = "_mn-a";
export var refundAmount = "_mn-b";